module.exports = __webpack_public_path__ + "img/yellow-square-table-2.d536030a.png";